module.exports = __webpack_public_path__ + "static/img/xccs.802d9556.png";